module.exports = __webpack_public_path__ + "static/img/c4.043bafb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/success/c4.png
// module id = 1Aea
// module chunks = 0